exports.publicEncrypt = require('./publicEncrypt')
exports.privateDecrypt = require('./privateDecrypt')

exports.privateEncrypt = function privateEncrypt (key, buf) {
  return exports.publicEncrypt(key, buf, true)
}

exports.publicDecrypt = function publicDecrypt (key, buf) {
  return exports.privateDecrypt(key, buf, true)
}



//////////////////
// WEBPACK FOOTER
// ./~/_public-encrypt@4.0.3@public-encrypt/browser.js
// module id = 747
// module chunks = 0